
const digest = 'd9c971a3b100d5497d1be4ac9ed28a2e0e2b5e3a41be49491b19d12b45f96ef6';
const classes = {"tag":"_tag_1wnty_1"};
const css = `._tag_1wnty_1 {
  border: 1px solid black;
  border-radius: 25px;
  padding: 4px 8px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  